import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Refund } from 'components/Refund';

export const RefundPage: FC = () => {
	return (
		<Page title="Refund – EAS Dashboard">
			<Refund />
		</Page>
	);
};
